import { Component, OnInit } from '@angular/core';
import { from } from 'rxjs';
// Services
import { DashboardService } from '../../../services/dashboard.service';
import { ModuleService } from '../../../services/modules.service';
import { StorageService } from '../../../services/storage.service';
import { RegistrationService } from '../../../services/registration.service';
import { GlobalFlagsService } from '../../../services/global-flags.service';

import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../../commons/dialog/dialog.component';

@Component({
  selector: 'app-thumb-join-today',
  templateUrl: './thumb-join-today.component.html',
  styleUrls: ['./thumb-join-today.component.scss']
})
export class ThumbnailJoinTodayComponent implements OnInit {

  cancerExperienceRegistryLink = null;

  get getRegistryExperience(): any {
    return JSON.parse(localStorage.getItem('registryDashboardkLink'));
  }

  get isRegistryAvailable(): any {
    return this.moduleService.isRegistryAvailable();
  }


  constructor(private dashboardService: DashboardService,
    private moduleService: ModuleService,
    private registrationService: RegistrationService,
    private dialog: MatDialog,
    private globalFlagsService: GlobalFlagsService,
    private storageService: StorageService) { }

  ngOnInit() {
    //why is this empty?
  }

  checkUrl(e) {
    const cerAccess = from(this.registrationService.checkCerAccess());
    this.globalFlagsService.displayLoad(true);
    const popup = window.open('', 'Cancer Experience Registry');
    popup.blur();
    window.focus();
    popup.document.write('Loading...');
    cerAccess
      .subscribe((res) => {
        this.globalFlagsService.displayLoad(false);
        if (res.error !== null) {
          popup.close();
          setTimeout(() => window.scrollTo(0, 0));
          const errorMsg = res.error;
          this.globalFlagsService.pushErrorAlert({ errorMsg });
        } else {
          popup.location.href = res.url;
        }
      }, (err) => {
        popup.close();
        this.globalFlagsService.displayLoad(false);
        const data = { message: 'Server has encountered a problem. <br>Sorry for inconvenience, we are working on it. Please try again.' };
        this.dialog.open(DialogComponent, { data });
        throw err;
      });
  }
}
